import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PursesEffects } from './purses.effects';
import { IPursesFeature } from './purses.feature.state';
import { PursesReducer } from './purses.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IPursesFeature>('PursesFeature'), PursesReducer),
    EffectsModule.forFeature([PursesEffects]),
  ],
})
export class PursesStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: PursesStateModule
  ) {
    if (parentModule) {
      throw new Error('PursesStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
